import clsx from 'clsx';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../Translations';
import Button from '../../../../../../Form/Button';
import LearningCollectionEditStore from '../../../../Edit/Store';
import { SectionContext } from '../../../../Types';
import Store from '../Store';
import { ExperienceResource, ExperiencesResource } from '../Types';

interface Props {
  learningCollectionStore: LearningCollectionEditStore;
  experiences: ExperiencesResource;
  store: Store;
  context: SectionContext;
  resource: ExperienceResource;
}

const addExperienceStore = (
  learningCollectionStore: LearningCollectionEditStore,
  context: SectionContext,
  resource: ExperienceResource,
  store: Store,
  experiences: ExperiencesResource,
) => {
  learningCollectionStore.addExperienceStoreWithSelectedIds(context, resource, store.selectedIds);
  store.loaded(experiences);
};

const SubmitButtons: React.FC<Props> = ({
  learningCollectionStore,
  experiences,
  store,
  context,
  resource,
}) => (
  <div className="mt-12 flex items-center">
    <Button
      type="button"
      value="Add program"
      onClick={() =>
        addExperienceStore(learningCollectionStore, context, resource, store, experiences)
      }
      className={clsx(
        fromEmpty(store.selectedIds)
          .map(() => 'cursor-pointer')
          .getOrElseValue('pointer-events-none opacity-50'),
        'mr-4 w-fit cursor-pointer rounded-lg bg-green-600',
        'px-5 py-2.5 text-sm font-light tracking-wide text-white hover:opacity-80',
      )}
    />
    <div
      className="cursor-pointer font-semibold text-teal-600"
      onClick={() => store.loaded(experiences)}
    >
      <T kind="Cancel" />
    </div>
  </div>
);

export default observer(SubmitButtons);
